import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ListiniApi, GetListiniAnimaliDettagliRequest, GetListiniPulciniRequest, GetListiniPulciniDettagliRequest } from "../data/apis/ListiniApi";
import { useContext } from "react";
import FilieraContext from "../contexts/filieraContext";

export function listiniPulciniDettagliDataSource(idListinoTestata: number, showAll:boolean) {
    return new CustomStore({
        key: "id",
        loadMode : 'raw',
        load: (loadOptions) => {
                    const api = new ListiniApi(apiConfiguration);
        
                    const request: GetListiniPulciniDettagliRequest = {
                        idListinoTestata: idListinoTestata,
                        showAll: showAll
                    };
        
                    return api.getListiniPulciniDettagli(request);
                },
        

        byKey: (key) => {
            const api = new ListiniApi(apiConfiguration);

            return api.getListinoPulciniDettaglioById({
                id: key
            });
        },

        insert: (values) => {
            const api = new ListiniApi(apiConfiguration);

            return api.insertListinoPulciniDettaglio({
                idListinoTestata: idListinoTestata,
                listinoPulciniDettaglioCreateDTO: values
            });
        },

        update: (key, values) => {
            const api = new ListiniApi(apiConfiguration);
            return api.updateListinoPulciniDettaglio({
                id: key,
                listinoPulciniDettaglioUpdateDTO: values
            });
        },

        remove: (key) => {
            const api = new ListiniApi(apiConfiguration);
            return api.deleteListinoPulciniDettaglio({
                id: key,
            });
        }
    });
}
